<template>
      <div v-if="!FirstName" class="loading-shade">
        <div class="loading-spinner"></div>
    </div>

<main v-if="FirstName">
    <div class="heroImg">
      <img src="https://cdn.assetrepository.me/leads-emailer/email-images/adventure-club/landing-bg.jpg" class="largeView" alt="Nissan" loading="lazy">
      <img src="https://cdn.assetrepository.me/leads-emailer/email-images/adventure-club/landing-bg-mob-edit.jpg" class="mobView" alt="Nissan" loading="lazy">

      <div class="detail">

   
        <div class="head">ARE YOU READY FOR<br>
          ADVENTURE?</div>
          <p>Date: {{ NSA_Bookingdate__c }} </p>
          <p>Venue: {{Region__c }} </p>
          <p style="border: 0;">Course: {{  NSA_DrivingExperience__c }}  </p>
          <div class="action">
            <a href="javascript:" @click="addEventToCalendar" class="heroBtn" >ADD TO CALENDAR
            </a>
         

            
            <a :href="'/update-owner/?sales_force_id='+sales_force_id" class="heroBtn">AMEND/CANCEL BOOKING
            </a>
          </div>

      </div>
    </div>
    <div class="headerHolder">
      <header>
        <a class="header-logo" href="https://www.nissan.co.za/" target="_blank">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
            y="0px" viewBox="0 0 504 421.7" style="enable-background:new 0 0 504 421.7;" xml:space="preserve"
            class="desktop">
          
            <g id="Layer_1_1_">
              <g id="Nissan_Badge_1_">
                <g>
                  <path class="st0" 
                    d="M293.7,227.7c-0.4,0.1-2,0.1-2.7,0.1h-51.6v12h52.5c0.4,0,3.5,0,4.1-0.1c10.7-1,15.6-9.9,15.6-17.7
                          c0-8-5.1-16.6-14.8-17.5c-1.9-0.2-3.5-0.2-4.2-0.2h-34.3c-1.5,0-3.2-0.1-3.8-0.3c-2.7-0.7-3.7-3.1-3.7-5.1c0-1.8,1-4.2,3.8-5
                          c0.8-0.2,1.7-0.3,3.6-0.3h49.5v-11.8h-50.3c-2.1,0-3.7,0.1-5,0.3c-8.6,1.2-14.6,8.1-14.6,16.9c0,7.2,4.5,15.6,14.4,17
                          c1.8,0.2,4.3,0.2,5.4,0.2H291c0.6,0,2.1,0,2.4,0.1c3.8,0.5,5.1,3.3,5.1,5.8C298.5,224.5,297,227.1,293.7,227.7z">
                  </path>
                  <path class="st0"
                    d="M195.9,227.7c-0.4,0.1-2,0.1-2.6,0.1h-51.7v12h52.5c0.4,0,3.5,0,4.1-0.1c10.7-1,15.6-9.9,15.6-17.7
                          c0-8-5.1-16.6-14.8-17.5c-1.9-0.2-3.5-0.2-4.2-0.2h-34.3c-1.5,0-3.2-0.1-3.8-0.3c-2.7-0.7-3.7-3.1-3.7-5.1c0-1.8,1-4.2,3.8-5
                          c0.8-0.2,1.7-0.3,3.6-0.3h49.5v-11.8h-50.3c-2.1,0-3.7,0.1-5,0.3c-8.6,1.2-14.6,8.1-14.6,16.9c0,7.2,4.5,15.6,14.4,17
                          c1.8,0.2,4.3,0.2,5.4,0.2h33.4c0.6,0,2.1,0,2.4,0.1c3.8,0.5,5.1,3.3,5.1,5.8C200.7,224.5,199.3,227.1,195.9,227.7z">
                  </path>
                  <rect x="101.7" y="181.4" class="st0" width="13" height="58.7"></rect>
                  <polygon class="st0" points="73,240.1 73,181.4 60,181.4 60,225.2 16.7,181.4 0,181.4 0,240.1 13,240.1 13,196.1 56.6,240.1
                          "></polygon>
                  <polygon class="st0" points="491.1,181.4 491.1,225.2 447.8,181.4 431.1,181.4 431.1,240.1 444.1,240.1 444.1,196.1 487.6,240.1
                          504,240.1 504,181.4    "></polygon>
                  <path class="st0" d="M363.4,181.4l-36.6,58.7h15.8l6.5-10.5h42.7l6.5,10.5H414l-36.6-58.7H363.4z M385.1,218.5h-29.3l14.7-23.6
                          L385.1,218.5z"></path>
                  <path class="st0" d="M72.3,148.1C98.5,71.6,170.7,20.2,252.1,20.2s153.7,51.4,179.8,127.9l0.2,0.6h57.3v-6.9l-23.8-2.8
                          c-14.7-1.7-17.8-8.2-21.8-16.4l-1-2C408.4,47.4,333.5,0,252.1,0C170.6,0,95.8,47.4,61.4,120.8l-1,2c-4,8.2-7.1,14.7-21.8,16.4
                          L14.8,142v6.9H72L72.3,148.1z"></path>
                  <path class="st0" d="M432.1,272.9l-0.2,0.6c-26.2,76.5-98.4,127.8-179.8,127.8l0,0c-81.4,0-153.7-51.4-179.8-127.9l-0.2-0.6H14.9
                          v6.9l23.8,2.8c14.7,1.7,17.8,8.2,21.8,16.4l1,2c34.4,73.4,109.3,120.8,190.7,120.8l0,0c81.4,0,156.3-47.4,190.7-120.7l1-2
                          c4-8.2,7.1-14.7,21.8-16.4l23.8-2.8v-6.9L432.1,272.9z"></path>
                </g>
                <g id="Layer_2_2_">
                  <g id="Layer_3_1_">
                  </g>
                </g>
              </g>
            </g>
          </svg> </a>
      </header>

    </div>
    <div class="wrapperHero">
        <div class="welcomePart">
          Now that you’re all set,
          here are a few short reference videos that will help you set up your vehicle in no time!
        </div>

        <a href="https://www.nissan.co.za/owners/reference-videos/navara.html" class="heroBtn" target="_blank">WATCH FEATURE VIDEOS</a>

    </div>

  </main>

  <footer lang="en" dir="ltr">
    <p class="copy">
      © Nissan 2024
    </p>
  </footer>

</template>

<script>
import axios from 'axios';
import {  base_be_url } from '@/utils/api';
import {  dietaryOptions } from '@/utils/constants';
import ical from 'ical-generator';


// import adobeAnalytics from "@/plugin/analytics";

export default {

    data() {
        return {
            isFocused: false,
            sales_force_id: this.$route.query.sales_force_id,
            Title: "",
            Email: "",
            LastName: "",
            FirstName: "", 
            NSA_Bookingdate__c: "",
            NSA_DrivingExperience__c: "",
            Region__c:"",
            MobilePhone: "",
            isMobileValid: true,
            isError:false,
            errorMessage: "",
            showThankYouMessage: false,
            dietaryOptions: dietaryOptions,
            selectedDietaryRequirements: [],
            dietaryRequirementsOnSubmit: false,
        };
    },
    methods: {

        addEventToCalendar() {
          const event = ical({
        domain: 'nissan.co.za',
        name: 'ADVENTURE CLUB',
        timezone: 'Africa/Johannesburg', // South Africa timezone
        location: this.Region__c,
      });

      const startDate = new Date(this.NSA_Bookingdate__c); // Current date
      const endDate = new Date(this.NSA_Bookingdate__c);
      endDate.setDate(startDate.getDate() + 1); // Setting end date to tomorrow

      event.createEvent({
        start: startDate,
        end: endDate,
        location: this.Region__c,
        summary: 'ADVENTURE CLUB',
        allDay: true, // All-day event
      });

      const calendarData = event.toString();
      const blob = new Blob([calendarData], { type: 'text/calendar;charset=utf-8' });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'event.ics');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

     

        fetchData() {
            try {
                const salesForceId = this.$route.query.sales_force_id;
                const apiUrl = `${base_be_url}?sales_force_id=${salesForceId}`;

                axios.get(apiUrl)
                    .then(response => {
                        // Handle the successful response
                        const res = response.data;
                        if (res.success && res.response.totalSize > 0 ) {
                            this.FirstName = res.response.records[0].FirstName;
                            this.LastName = res.response.records[0].LastName;
                            this.NSA_Bookingdate__c = res.response.records[0].NSA_Bookingdate__c;
                            this.NSA_DrivingExperience__c = res.response.records[0].NSA_DrivingExperience__c;
                            this.Region__c = res.response.records[0].Region__c;
                            this.MobilePhone = res.response.records[0].MobilePhone;
                        }
                        else{
                               this.$router.push(`/`);

                        }
                    })
            } catch (error) {
                console.log('ower not found');
                this.$router.push('/');
            }
        },
      
      
    },
    mounted() {
        // Fetch data when the component is mounted
        this.fetchData();
        const form = document.getElementById("guestForm");
        if (!form) return; // Ensure the form element exists
        // Get all input, select, checkbox, and radio elements within the form
        const elements = form.querySelectorAll("input, select, checkbox, radio");
        // Add focus event listener to each element
        elements.forEach(element => {
          element.addEventListener("focus", this.onFocus);
        });
    },

};
</script>

<style scoped>
body{
    background-color: #000;
}
 @media screen {
    @font-face {
      font-family: "NissanBrand Light";
      font-weight: 300;
      font-display: swap;
      src: local("Nissan Brand Light");
      src: url('https://cdn.assetrepository.me/nissan-font/font/NissanBrand-Light.woff');
    }

    @font-face {
      font-family: "NissanBrand";
      font-weight: 400;
      font-display: swap;
      src: local("Nissan Brand Regular");
      src: url('https://cdn.assetrepository.me/nissan-font/font/NissanBrand-Regular.woff');
    }

    @font-face {
      font-family: "NissanBrand Bold";
      font-weight: 700;
      font-display: swap;
      src: local("Nissan Brand Bold");
      src: url('https://cdn.assetrepository.me/nissan-font/font/NissanBrand-Bold.woff');
    }
  }

  @font-face {
    font-family: "FontAwesome";
    font-weight: normal;
    font-style: normal;
    src: url("https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/fonts/fontawesome-webfont.eot?v=4.3.0");
    src: url("https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/fonts/fontawesome-webfont.eot?#iefix&v=4.3.0") format("embedded-opentype"),
      url("https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/fonts/fontawesome-webfont.woff2?v=4.3.0") format("woff2"),
      url("https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/fonts/fontawesome-webfont.woff?v=4.3.0") format("woff"),
      url("https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/fonts/fontawesome-webfont.ttf?v=4.3.0") format("truetype"),
      url("https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/fonts/fontawesome-webfont.svg?v=4.3.0#fontawesomeregular") format("svg");
  }


  * {
    font-family: 'NissanBrand', Arial, Helvetica, sans-serif;
    font-style: normal;
    color: #fff;
  }

  .st0{
     fill: #fff;
  }


  main {
    
    margin: 0;
    padding: 0;
  }


  main {
    display: flex;
    flex-direction: column;
    background-color: #000;
    color: #fff;
  }

  main {
    flex: 1 0 auto;
    /* max-width: 1500px; */
    margin: 0 auto;
    padding: 0;
    text-align: center;
    width: 100%;
    position: relative;
  }

  main div.heroImg {
    width: 100%;
    padding-top: 56em;
    /* position: relative; */
    display: flex;
    flex-direction: column;
  }

  main div.heroImg img {
    position: absolute;
    inset: 0;
    opacity: 1;
    max-width: 100%;
    max-height: 100%;
    height: 100%;
    object-fit: cover;
  }

  footer {
    flex-shrink: 0;
    padding: 0.3rem;
    background-color: #000;
    color: #fff;
    text-align: center;
    border-top: 1px solid #282828;
  }

  footer * {
    color: #fff;
  }

  .wrapperHero {
    position: absolute;
    top: auto;
    bottom: 5em;
    left: 50%;
    transform: translateX(-50%);
    width: 75%;
    display: flex;
    justify-content: space-between;
    align-items: center;

  }
  .welcomePart{
    font-size: 2rem;
    text-align: left;
    max-width: 55%;
    width: 100%;
    font-family: "NissanBrand Light";
  }

  .headerHolder {
    position: absolute;
    top: 19px;
    bottom: auto;
    left: 19px;
  }

  header {
    padding: 1rem;
  }

  .header-logo {
    display: block;
    text-align: center;
  }

  .header-logo svg {
    width: 115px;
  }


  h1 {
    text-transform: uppercase;
  }

  .welcomeBody {
    margin-top: 0.75em;
  }

  h1.head {
    font-size: 20px;
    margin: 0;
    letter-spacing: 0.5px;

  }

  h3.headMuted {
    font-size: 15px;
    margin: 0;
    font-family: "NissanBrand Light";
    letter-spacing: 0.5px;
    padding-top: 5px;

  }

  h1 span {
    display: block;
  }

  h1 span:first-child {
    font-size: 1rem;
  }

  .content {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }

  img {
    width: 100%;
    height: auto;
  }

  .button {
    padding: .7rem 1.5rem;
    text-decoration: none;
    background-color: #c30e29;
    color: #fff;
    text-transform: uppercase;
    min-width: 160px;
    transition: all .3s ease-out;
  }

  .button:hover,
  .button:focus,
  .button:active {
    background-color: #920023;
  }

  .w-100 {
    width: 100%;
    max-width: 100%;
  }

  .bgHero {
    /* background: url('/herolanding1.jpg'); */
    max-height: 1200px;
    background-size: contain;
    background-repeat: no-repeat;
    width: 100%;
    background-position: center center;
    display: flex;
    flex-direction: column;
  }

  .contentCopy {
    font-size: 15px;
    word-wrap: break-word;
    line-height: 1.4;
    position: relative;
    padding-top: 15px;
  }

  .contentCopy::after {
    content: "";
    width: 65px;
    height: 3px;
    background-color: #c3002f;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);


  }

  .modelBox {
    max-width: 100%;
    margin: auto;
    margin-bottom: 0;
    display: block;
    width: 100%;
  }

  ul.models {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    padding: 0;
    margin: 2em 0;
  }

  ul.models li {
    display: flex;
    flex-basis: 25%;
    justify-content: center;
    align-items: center;
    text-align: center;
    flex-direction: column;
  }

  ul.models li .model {
    font-size: 13px;
  }

  ul.models li a,.heroBtn {
    font-size: 16px;
    text-decoration: none;
    text-transform: uppercase;
    border-radius: 40px;
    background: #fff;
    padding: 15px 15px;
    color: #000;
    font-family: 'NissanBrand Bold';
    margin-top: 9px;
    display: flex;
    align-items: center;
    line-height: 24px;
  }
  .heroBtn i {
    font-size: 23px;
    color: #000;

  }

  ul.models li a i {
    color: #000;
    font-size: 19px;
  }
  .heroBtn.topView{
    position: absolute;
    transform: translateY(-50%);
    left: 15em;
    /* width: 12%; */
    justify-content: center;
    max-width: 100%;
    top: 50%;
  }


  @media screen and (min-width: 1420px) {
    .contentCopy {
      padding-left: 3em;
      padding-right: 3em;
    }


  }

  @media print,
  screen and (min-width: 1024px) {
    .mobView {
      display: none
    }

    .largeView {
      display: block
    }
  }

  /* @media screen and (max-width: 1320px) {
    .wrapperHero {
      width: 70%;
    }

  } */

  @media screen and (max-width: 1024px) {
    .wrapperHero {
      width: 100%;
      margin: 0 auto;
    }

    .mobView {
      display: none
    }

    .largeView {
      display: block
    }

    main div.heroImg img {
      object-fit: cover;
    }

    main div.heroImg {
      padding-top: 55em;
    }
  }


  @media screen and (max-width: 667px) {
    main{
      height: 100vh;
    }
    .header-logo svg {
    width: 81px;
}
    .mobView {
      display: block;
    }
    .welcomePart {
      font-size: 1rem;
      text-align: center;
      max-width: 93%;
    }
    .heroBtn{
      padding: 10px 15px;
    }

    .header-logo svg {
      filter: none;
    }

    .largeView {
      display: none;
    }

    main div.heroImg {
      /* padding-top: 89em; */
      padding-top: 29rem;
      display: flex;
      padding-bottom: 0em;
    }

    .wrapperHero {
      height: auto !important;
      display: flex;
      bottom: 30px;
      flex-direction: column;
    }

    ul.models {
      flex-direction: column;
      width: 100%;
      margin-top: 2em;

    }

    ul.models li {
      flex-basis: auto;
      align-items: center;
      margin-bottom: 1.5em;
    }

    main picture.heroImg img {
      object-fit: cover;
    }

    ul.models li img {
      width: 65%;
    }

    .modelBox {
      max-width: 100%;
    }

    .headerHolder {
      width: 100%;
      left: 0;
    }

    h1.head {
      font-size: 1.25rem;
      color: #fff;
    }

    .headMuted {
      color: #fff;
      font-size: 12px !important
    }

    /*.wrapperHero {
       height: calc(100% - 96px) !important;

      height: 100% !important; }*/
      .heroBtn.topView {
        left: 50%;
        width: 85%;
        top: 65%;
        transform: translateX(-50%);
        transform: translateX(-50%) translateY(-50%);
    }


  }

  .copy {
    font-size: 11px;
  }
  .detail{
    width: 31em;
    max-width: 100%;
    position: absolute;
    top: 15em;
    left: 2.5em;
    background: rgba(0, 0, 0, 0.5);
    text-align: left;
    padding: 15px;
  }
  .detail .head{
    font-size: 2rem;
    line-height: 1.1;
    font-family: "NissanBrand Bold";
    margin-bottom: 15px;
  }
  .detail p{
    border-bottom: 1px solid #fff;
    padding: 7px 0;
    width: max-content;
    margin: 0;
  }
  .action{
    display: flex;
    flex-direction: row;
    margin: 1em 0;
  }
  .action a{
    width: 100%;
    margin: 0 5px;
    padding: 11px 15px;
    text-align: center;
    justify-content: center;
    font-size: 15px;
  }
  @media screen and (max-width: 667px) {
    .detail{
      top: 8em;
      left: 0;
      width: 100%;
      right: 0;
    }
    .action{
      flex-direction: column;
    }
    .action a {
     width: 85%;
     margin: 0.55em 0;
    }
}

</style>